import { deserialisePeople } from '../../api/lendingAPI/CustomerStateAPIHelper';
import { mergeStates } from '../../iwProvider/StoreHelper';
import {
    ADD_PAYMENT_METHOD_COMPLETED,
    REGISTER_BANK_ACCOUNT_SUCCESS
} from '../modals/addPaymentMethodModal/AddPaymentMethodModal.actions';
import {
    EDIT_DEBIT_CARD_COMPLETED,
    UPDATE_BANK_ACCOUNT
} from '../modals/editPaymentMethodModal/EditPaymentMethodModal.actions';
import { PERSON_FORM_SUBMIT_COMPLETED } from '../modals/personModal/PersonModal.actions';
import {
    REQUEST_COMPANY_LOOKUP_COMPLETED,
    REQUEST_COMPANY_LOOKUP_LOADING,
    SUBMIT_COMPANY_DETAILS_COMPLETED,
    SUBMIT_COMPANY_DETAILS_LOADING,
    TOGGLE_MANUAL_COMPANY_STATE
} from './companyDetails/CompanyDetails.actions';
import {
    CANCEL_PROMPT,
    LEAVE_PROFILE,
    OPEN_PROMPT,
    PROFILE_DATA,
    PROFILE_DATA_LOADING,
    TOGGLE_ADD_DEBIT_CARD_FORM
} from './Profile.actions';
import { getPaymentMethods, setYourCompanyState } from './ProfileHelper';

export const initialState = {
    ready: false,
    openPrompt: false,

    people: [],
    company_name: '',
    company_number: '',
    companyType: { value: '', label: '' },
    website: '',
    companies: [],
    fetchCompaniesPending: false,
    showManualCompany: false,
    showAddDebitCardForm: false,
    showAddBankAccountForm: true
};

// eslint-disable-next-line import/no-default-export
export default function (state = mergeStates(initialState), action = {}) {
    switch (action.type) {
        case OPEN_PROMPT:
            return mergeStates(state, {
                openPrompt: true
            });

        case CANCEL_PROMPT:
            return mergeStates(state, {
                openPrompt: false
            });

        case PROFILE_DATA_LOADING:
            return mergeStates(state, {
                ready: false
            });

        case REQUEST_COMPANY_LOOKUP_COMPLETED:
            return mergeStates(state, {
                fetchCompaniesPending: false,
                companies: action.companies
            });

        case REQUEST_COMPANY_LOOKUP_LOADING:
            return mergeStates(state, {
                fetchCompaniesPending: true
            });

        case TOGGLE_MANUAL_COMPANY_STATE:
            return mergeStates(state, {
                showManualCompany: !state.showManualCompany
            });

        case SUBMIT_COMPANY_DETAILS_LOADING:
            return mergeStates(state, {
                submitCompanyDetailsLoading: true
            });

        case SUBMIT_COMPANY_DETAILS_COMPLETED:
            return mergeStates(state, {
                submitCompanyDetailsLoading: false
            });

        case PERSON_FORM_SUBMIT_COMPLETED:
            return {
                ...state,
                people: deserialisePeople(action.people)
            };

        case ADD_PAYMENT_METHOD_COMPLETED:
        case EDIT_DEBIT_CARD_COMPLETED:
            return {
                ...state,
                paymentMethods: getPaymentMethods(action.payment_method)
            };
        case UPDATE_BANK_ACCOUNT:
            return {
                ...state,
                linkingBankAccount: false,
                showAddBankAccountForm: true
            };

        case TOGGLE_ADD_DEBIT_CARD_FORM:
            return mergeStates(state, {
                showAddDebitCardForm: !state.showAddDebitCardForm
            });

        case REGISTER_BANK_ACCOUNT_SUCCESS:
            return mergeStates(state, {
                showAddBankAccountForm: !(
                    state.paymentMethods &&
                    state.paymentMethods.find(
                        (paymentMethod) => paymentMethod.type === 'bank_account'
                    )
                )
            });

        case PROFILE_DATA:
            return mergeStates(state, setYourCompanyState(action));

        case LEAVE_PROFILE:
            return mergeStates(initialState);

        default:
            return state;
    }
}
